<template>
    <div id="index">
        <div class="ui middle aligned center aligned grid">
            <div class="column">
                <h1 class="ui header">
                    <i class="red huge warning icon"></i>
                    404 not found.
                </h1>
                <h1 class="ui header">
                    <!-- 找不到頁面 -->
                    {{ $t("ui.pages.partials.page_404.cant_find_page") }}
                </h1>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
    },
    data() {
        return {
            is_loading: false
        }
    },
    mounted() {
        this.set_breadcrumbs()
    },
    watch: {
        '$route'(to, from) {
            this.set_breadcrumbs()
        }
    },
    methods: {
        set_breadcrumbs() {
            this.$store.state.breadcrumbs = [{
                route_name: 'page_404',
                name: '找不到頁面'
            }]
        }
    },
    components: {

    },
    computed: {

    }
}
</script>

<style scoped>
.ui.main {

}
</style>
